// extracted by mini-css-extract-plugin
module.exports = {"container":"NoData_container__3s1_r","content":"NoData_content__BnysC","big":"NoData_big__2NFpZ"};